module.exports = __webpack_public_path__ + "img/xiaomai.49e4ea32.jpg";